import apiClient from './client';

function resolveStoredToken(rawToken) {
  if (!rawToken) {
    return null;
  }
  if (typeof rawToken === 'string') {
    const trimmed = rawToken.trim();
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
      return null;
    }
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && typeof parsed === 'object' && parsed.token) {
        return resolveStoredToken(parsed.token);
      }
    } catch (error) {
      // Not JSON, fall through to returning the trimmed string.
    }
    return trimmed;
  }
  if (typeof rawToken === 'object' && rawToken.token) {
    return resolveStoredToken(rawToken.token);
  }
  return null;
}

function adminAuthHeaders() {
  if (typeof window === 'undefined') return {};
  const token = resolveStoredToken(window.localStorage.getItem('asi:admin-token'));
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function login(payload) {
  return apiClient.post('/auth/users/login', payload);
}

export function verifyRegistration(payload) {
  return apiClient.post('/auth/users/register/verify', payload);
}

export function resendRegistrationVerification(payload) {
  return apiClient.post('/auth/users/register/resend', payload);
}

export function register(payload) {
  return apiClient.post('/auth/users/register', payload);
}

export function requestPasswordReset(payload) {
  return apiClient.post('/auth/users/password/forgot', payload);
}

export function resetPassword(payload) {
  return apiClient.post('/auth/users/password/reset', payload);
}

export function adminLogin(payload) {
  return apiClient.post('/auth/admin/login', payload);
}

export function refreshSession(payload) {
  return apiClient.post('/auth/refresh', payload);
}

export function createAdmin(payload) {
  return apiClient.post('/auth/admin/create', payload, {
    headers: adminAuthHeaders(),
  });
}
